import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_icon = _resolveComponent("icon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_sub_menu = _resolveComponent("sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    collapsible: true,
    style: _normalizeStyle({
    height: '100%',
    width: _ctx.collapsed == true ? '40px' : '100%',
  })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        width: _ctx.collapsed ? '40px' : '100%',
        collapsed: _ctx.collapsed
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout, null, {
            default: _withCtx(() => [
              (_ctx.showQueryMenu)
                ? (_openBlock(), _createBlock(_component_a_layout_header, {
                    key: 0,
                    style: {"padding":"0px 4px","height":"34px","line-height":"34px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.state.menuName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.menuName) = $event)),
                        size: "small"
                      }, {
                        suffix: _withCtx(() => [
                          _createVNode(_component_search_outlined)
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_layout_content, {
                theme: _ctx.theme,
                style: _normalizeStyle({
          padding: '0px',
          width: _ctx.collapsed == true ? '40px' : '100%',
        })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu, {
                    theme: _ctx.theme,
                    selectedKeys: _ctx.state.selectedKeys,
                    "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.selectedKeys) = $event)),
                    mode: _ctx.showMode,
                    style: {
            padding: '0px',
          },
                    onClick: _ctx.menuSelect
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTree, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.key
                        }, [
                          (!item.children)
                            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: item.key
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_icon, {
                                    icon: item.icon ? item.icon : '',
                                    twoToneColor: item.color ? item.color : ''
                                  }, null, 8, ["icon", "twoToneColor"])
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" " + _toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_sub_menu, {
                                "menu-info": item,
                                key: item.key
                              }, null, 8, ["menu-info"]))
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["theme", "selectedKeys", "mode", "onClick"])
                ]),
                _: 1
              }, 8, ["theme", "style"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["width", "collapsed"])
    ]),
    _: 1
  }, 8, ["style"]))
}